module.exports = __webpack_public_path__ + "img/linkedin.f86f4265.png";